import { resolvePath, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '@wojtekmaj/react-t';
import { ChevronLeftIcon } from 'lucide-react';

import { Button } from './back_button.styles';

type BackButtonProps = Omit<React.ComponentProps<typeof Button>, 'to' | 'title'> & {
  mode?: 'back' | 'up';
};

export default function BackButton({ mode = 'back', ...otherProps }: BackButtonProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const backString = useTranslation('Back');

  return (
    <Button
      {...otherProps}
      onClick={() => {
        if (mode === 'back') {
          navigate(-1);
        } else {
          navigate(resolvePath('..', location.pathname));
        }
      }}
      title={backString}
    >
      <ChevronLeftIcon size={28} />
    </Button>
  );
}
